// App.js
import React, { useState } from 'react';
import './App.css';
import { AIProvider } from './contexts/AIContext';
import Header from './components/Header';
import FeaturesList from './components/FeaturesList';
import VocabularyLearning from './components/VocabularyLearning';
import PronunciationTraining from './components/PronunciationTraining';
import AITutor from './components/AITutor';

function App() {
  const [currentView, setCurrentView] = useState('features');
  const [cart, setCart] = useState([]);

  const addToCart = (item) => {
    setCart([...cart, item]);
  };

  return (
    <AIProvider>
      <div className="App">
        <Header cartCount={cart.length} />
        
        {currentView === 'features' && (
          <FeaturesList 
            onNavigate={setCurrentView}
            onAddToCart={addToCart}
          />
        )}
        
        {currentView === 'vocabulary' && (
          <VocabularyLearning onBack={() => setCurrentView('features')} />
        )}
        
        {currentView === 'pronunciation' && (
          <PronunciationTraining onBack={() => setCurrentView('features')} />
        )}
        
        {currentView === 'ai-tutor' && (
          <AITutor onBack={() => setCurrentView('features')} />
        )}
      </div>
    </AIProvider>
  );
}

export default App;